import { chartColors } from '../config/analyticsCharts';

// Static mapping of common categories to specific colors
// This ensures consistent coloring across the application
export const categoryColorMap: Record<string, string> = {
  // Appointment types
  'First Visit': '#1E88E5', // Blue
  'Follow up': '#43A047',   // Green
  'Free Consultation': '#FFB300', // Amber
  
  // Insurance types
  'IPM': '#1E88E5', // Blue
  'PAF': '#8E24AA', // Purple
  'PAL': '#43A047', // Green
  'Personnel': '#FFB300', // Amber
  
  // Sex categories
  'Male': '#1E88E5', // Blue
  'Female': '#E53935', // Red

  // Common test types
  'Blood Test': '#1E88E5', // Blue
  'X-Ray': '#8E24AA',      // Purple
  'Ultrasound': '#43A047', // Green
  'MRI': '#FFB300',        // Amber
  
  // Other common categories
  'Yes': '#43A047', // Green
  'No': '#E53935',  // Red
};

// Map to remember dynamically assigned colors
const dynamicColorMap: Record<string, string> = {};

/**
 * Gets a consistent color for a category name
 * @param categoryName The name of the category (appointment type, insurance, etc.)
 * @returns A hex color code
 */
export const getCategoryColor = (categoryName: string): string => {
  // Skip empty or undefined categories
  if (!categoryName) {
    return chartColors.seriesColors[0]; // Default blue
  }
  
  // 1. Try exact match from predefined categories
  if (categoryColorMap[categoryName]) {
    return categoryColorMap[categoryName];
  }
  
  // 2. Try case-insensitive match from predefined categories
  const lowerName = categoryName.toLowerCase();
  const predefinedKey = Object.keys(categoryColorMap)
    .find(key => key.toLowerCase() === lowerName);
    
  if (predefinedKey) {
    return categoryColorMap[predefinedKey];
  }
  
  // 3. Check if we've dynamically assigned this category before
  if (dynamicColorMap[categoryName]) {
    return dynamicColorMap[categoryName];
  }
  
  // 4. Assign a new consistent color based on string hash
  const hash = categoryName.split('').reduce((total, char, i) => {
    return total + (char.charCodeAt(0) * (i + 1));
  }, 0);
  
  const colorIndex = Math.abs(hash) % chartColors.seriesColors.length;
  const color = chartColors.seriesColors[colorIndex];
  
  // Save for consistent future lookups
  dynamicColorMap[categoryName] = color;
  
  console.log(`Assigned color ${color} to category "${categoryName}"`);
  return color;
};

/**
 * Gets a set of colors for an array of categories
 * @param categoryNames Array of category names
 * @returns Array of corresponding colors
 */
export const getCategoryColors = (categoryNames: string[]): string[] => {
  return categoryNames.map(name => getCategoryColor(name));
}; 